import "./AudioFormField.css"

import PrimaryInput from "../primaryInput/PrimaryInput";
import {ErrorMessageStyle, ErrorMessage} from "../errorMessage/ErrorMessage";
import RemoveButton from "../removeButton/RemoveButton";

import {useEffect, useState} from "react";
import {useDashboardLocale} from "../../context/dashboard_locale";

import {capitalize} from "../../utils/strings";

export function MediaFileContent(id, file, titleFile, originName) {
  return {
    id: id,
    file: file,
    titleFile: titleFile,
    originName: originName,
  }
}

export function MediaFormField(props) {
    const {strings} = useDashboardLocale();
    const mediaFileContent = props.mediaFileContent;
    const mediaID = mediaFileContent.id;
    const deleteDisabled = props.deleteDisabled;
    const fileNameValidationError = props.fileNameValidationError;
    const accept = props.accept;

    const [selectedFile, setSelectedFile] = useState(mediaFileContent.file);
    const [titleName, setTitleName] = useState(mediaFileContent.titleFile ?? "");
    const [originName, setOriginName] = useState(mediaFileContent.originName);

    useEffect(() => {
      setOriginName(mediaFileContent.originName);
      setTitleName(mediaFileContent.titleFile);
      setSelectedFile(mediaFileContent.file);
    }, [mediaFileContent]);

    const onChange = props.onChange;
    const onDelete = props.onDelete;

    function onChangeFile(e) {
        let files = e.target.files
        if (files.length > 0) {
            const selectedFile = files[0];
            const originName = selectedFile.name;
            setOriginName(originName);
            setSelectedFile(selectedFile)
            onChange(MediaFileContent(
              mediaID,
              selectedFile,
              titleName,
              originName,
            ));
        }
    }

    function onChangeFileName(e) {
      const newFileName = e.target.value;
      setTitleName(newFileName);
      onChange(MediaFileContent(
        mediaID,
        selectedFile,
        newFileName,
        originName,
      ));
    }

    function onDeleteClick(e) {
        e.preventDefault();
        onDelete(mediaID);
    }

    let fileNameClassName = "w-full";
    if (fileNameValidationError) {
      fileNameClassName = "w-full outline-none ring-2 ring-red-500";
    }

    return (
        <div className="my-4 flex flex-col items-stretch">
            <div className="mb-2 flex flex-row justify-center gap-8">
                <div className="w-1/6">
                    <PrimaryInput
                      name="file_name"
                      placeholder={strings["file_name"]}
                      type="text"
                      onChange={onChangeFileName}
                      extraClassName={fileNameClassName}
                    >
                      {mediaFileContent.titleFile}
                    </PrimaryInput>
                </div>
                <div className="grow flex gap-4">
                    <PrimaryInput
                        name="file"
                        type="file"
                        accept={accept}
                        extraClassName="audio-form-field-file-input"
                        onChange={onChangeFile}
                    />
                </div>
                <div className="w-1/6">
                    {originName && <p className="whitespace-nowrap overflow-hidden text-ellipsis shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight">{originName}</p>}
                </div>
                <div className="w-1/6">
                    <RemoveButton
                        disabled={deleteDisabled}
                        extraClassName={"w-full"}
                        onClick={onDeleteClick}
                    >
                        {capitalize(strings["delete"])}
                    </RemoveButton>
                </div>
            </div>
            {fileNameValidationError && (
              <div>
                <ErrorMessage style={ErrorMessageStyle.SMALL}>{fileNameValidationError}</ErrorMessage>
              </div>
            )}
        </div>
    );
}
